import type { Ref } from 'react';

import {
  IconButton,
  type Props as IconButtonProps,
} from 'atoms/buttons/IconButton';

interface Props extends IconButtonProps {
  active?: boolean;
  ref?: Ref<HTMLElement>;
}
export const MenuIconButton = (props: Props) => {
  const { active, className, ref, ...rest } = props;

  return (
    <IconButton ref={ref} {...rest} color="transparent" className={className} />
  );
};
